module.exports = __webpack_public_path__ + "img/icon-test.5f54b4da.png";